/**
 * Nouns: the word with its article, type what it means.
 *
 * The interaction lives in `GenderedTranslationFront`, shared with
 * Substantivos — the Portuguese deck asking the same question about the same
 * kind of word. This app doesn't test gender (Der·Die·Das does), so showing it
 * teaches it for free.
 */
import { GenderedTranslationFront } from '@/components/practice/GenderedNounCard';
import type { NounsPayload } from '@/core/types';

import type { CardFrontProps } from '../types';

export function CardFront({ card, onAnswer }: CardFrontProps<NounsPayload>) {
  return <GenderedTranslationFront card={card} onAnswer={onAnswer} />;
}
